import React from "react";
import Flex, { FlexProps } from "../Flex";
import Button, { ButtonProps } from "../Button";
import { BoxProps } from "../Box";

type ButtonPropsOverrides = Pick<ButtonProps, "text" | "onClick" | "disabled">;

type Props = {
  primary: ButtonPropsOverrides;
  secondary: ButtonPropsOverrides;
} & BoxProps &
  FlexProps;

const ModalFooter: React.FC<Props> = ({ primary, secondary, ...styles }) => {
  return (
    <Flex
      px="xxl"
      py="m"
      borderTop="default"
      background="grayLightest"
      alignItems="center"
      justifyContent="flex-end"
      flexShrink="0"
      {...styles}>
      {secondary ? (
        <Button id="modal-footer-secondary-button" buttonStyle="secondary" mr="s" {...secondary} />
      ) : null}

      <Button fullWidth={!secondary} id="modal-footer-primary-button" {...primary} />
    </Flex>
  );
};

export default ModalFooter;
